var map = {
	"./block.svg": 5340,
	"./cross.svg": 9163,
	"./ds.svg": 3102,
	"./ee.svg": 3999,
	"./fire.svg": 7965,
	"./gears.svg": 8063,
	"./globe.svg": 9960,
	"./head.svg": 5971,
	"./link.svg": 8965,
	"./map.svg": 3297,
	"./mind.svg": 5265,
	"./play.svg": 6995,
	"./rapport.svg": 3559,
	"./rocket.svg": 9545,
	"./uerj.svg": 8967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4335;